import React from "react";
import { DropdownMenuItem as DropdownMenuItemUI } from "../dropdown-menu";
import { OverflowDisplayTooltip } from "../Tooltip/OverflowDisplayTooltip";
import { Action } from "./types";
import {
  dropdownMenuItemVariants,
  dropdownMenuIconVariants,
  dropdownMenuTextVariants,
} from "./variants";

interface DropdownMenuItemProps<DataT> {
  action: Action<DataT>;
  item?: DataT;
}

export const DropdownMenuItem = <DataT,>({
  action,
  item,
}: DropdownMenuItemProps<DataT>) => {
  const {
    id,
    label,
    icon: Icon,
    variant,
    className,
    getDisabled,
    onClick,
    isDivider,
    shouldShow,
  } = action;

  if (isDivider) {
    return <div key={id} className="my-1 h-px bg-gray-200" />;
  }

  if (shouldShow === false) {
    return null;
  }

  return (
    <DropdownMenuItemUI
      key={id}
      onClick={(e: React.MouseEvent) => {
        e.stopPropagation();
        onClick?.(item || undefined);
      }}
      disabled={getDisabled?.(item || undefined) || false}
      className={dropdownMenuItemVariants({
        variant: variant || "primary",
        className: `group ${className}`,
      })}
    >
      {Icon && (
        <span
          className={dropdownMenuIconVariants({
            variant: variant || "primary",
          })}
        >
          <Icon />
        </span>
      )}
      {label && (
        <OverflowDisplayTooltip className="max-w-[150px]" content={label}>
          <span
            className={dropdownMenuTextVariants({
              variant: variant || "primary",
            })}
          >
            {label}
          </span>
        </OverflowDisplayTooltip>
      )}
    </DropdownMenuItemUI>
  );
};
